import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import { useInView } from 'react-intersection-observer';
import DevpageSidebarPlacement from '../../../../DealerAd/Placement/DevpageSidebar';
import s from './Dealer.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

const Dealer: React.FC<Props> = () => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <div ref={ref} className={s['root']}>
      {inView && <DevpageSidebarPlacement />}
    </div>
  );
};
Dealer.displayName = 'Dealer';

export default Dealer;
